import './Product.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { ROUTE_404 } from '@/common/constants';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';
import Product from '@/ebat/components/blocks/Product/Product';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import {
  ProductContainerDefaultProps,
  ProductContainerPropTypes,
} from './Product.proptypes';
import useProductModal from './useProduct';

const ProductContainer = ({ isDisabledIA }) => {
  const { id } = useParams();
  const { isDisabled, isError, isSuccess, product } = useProductModal({
    path: id,
  });

  if (isError) {
    return <Redirect to={ROUTE_404} />;
  }

  if (isDisabled.loading && !product) {
    return <PageLoader className="modal-scanbat-product" />;
  }

  if (isSuccess) {
    return (
      <Product
        isDisabledIA={isDisabledIA}
        agrementFgaz={product.agrement_fgaz}
        brand={product.brand}
        bundleParents={product.bundle_parents}
        categories={product.categories}
        className="page-product__product"
        codeOldCompanySku={product?.code_old_company_sku}
        companyAvailability={product.company_availability}
        complementaryDescription={product.complementary_description}
        configurations={product.configurator?.configurations}
        customerPrice={product.price_and_stock?.price?.customer_price}
        details={product.details}
        disabled={isDisabled.disabled}
        discountClasses={product.discount_classes}
        discountPrice={product.price_and_stock?.price?.discount_price}
        discountPriceTTC={
          product.price_and_stock?.price?.discount_price_incl_vat
        }
        energetics={product.energetics}
        exclusivity={product.exclusivity}
        flags={product.flags}
        hasPrice={product.price_and_stock?.has_price}
        hasStock={product.price_and_stock?.has_stock}
        id={product.id}
        image={product.image}
        imageSize={PRODUCTS_TYPES_FORMATS.MOSAIC}
        invoiceUnit={product.price_and_stock?.invoice_unit}
        isBundle={product.is_bundle}
        isFavorite={product.is_favorite}
        isLoading={isDisabled.loading}
        isSalable={product.is_salable}
        isLightDisplay
        links={product.links}
        mainSku={product.main_sku}
        manufacturerSku={product.manufacturer_sku}
        mustSubstitute={product.must_substitute}
        name={product.name}
        path={product.path}
        productDiff={product.diffs}
        publicPrice={product.price_and_stock?.price?.public_price}
        publicPriceTTC={product.price_and_stock?.price?.public_price_incl_vat}
        range={product.range}
        related={product?.related}
        saleUnit={product.price_and_stock?.sale_unit}
        salesPackaging={product.price_and_stock?.sales_packaging}
        sku={product.sku}
        slider={product.slider?.data?.slice(0, 1)}
        slug={product.slug}
        sortables={product?.sortables}
        splitPackaging={product.price_and_stock?.split_packaging}
        stockStatus={product.price_and_stock?.stock_status}
        stocks={product.price_and_stock?.stocks}
        substitute={product.substitute}
        video={product.video}
        weeeAmount={product.price_and_stock?.price?.weee_amount}
      />
    );
  }

  return null;
};

ProductContainer.defaultProps = {
  ...ProductContainerDefaultProps,
};

ProductContainer.propTypes = {
  ...ProductContainerPropTypes,
};

export default ProductContainer;
